export const darkTheme = [
  { key: '--root-color', value: '#212945' },
  { key: '--root-color-contrast', value: '#ffffff' },

  { key: '--color-primary-050', value: 'hsl(232, 34%, 99%)' },
  { key: '--color-secondary-050', value: 'hsl(214, 82%, 99%)' },
  { key: '--color-accent-050', value: 'hsl(270, 50%, 99%)' },

  { key: '--color-neutral-050', value: 'hsl(209, 14%, 85%)' },
  { key: '--color-neutral-100', value: 'hsl(209, 14%, 60%)' },
  { key: '--color-neutral-200', value: 'hsl(209, 14%, 50%)' },
  { key: '--color-neutral-300', value: 'hsl(205, 14%, 40%)' },
  { key: '--color-neutral-400', value: 'hsl(209, 14%, 30%)' },
  { key: '--color-neutral-500', value: 'hsl(209, 14%, 20%)' },
  { key: '--color-neutral-600', value: 'hsl(209, 14%, 15%)' },
  { key: '--color-neutral-700', value: 'hsl(209, 14%, 10%)' },
  { key: '--color-neutral-800', value: 'hsl(209, 14%, 5%)' },
  { key: '--color-neutral-900', value: 'hsl(209, 14%, 1%)' },

  { key: '--color-surface-050', value: 'hsl(209, 14%, 50%)' },
  { key: '--color-surface-100', value: 'hsl(211, 16%, 45%)' },
  { key: '--color-surface-200', value: 'hsl(213, 18%, 40%)' },
  { key: '--color-surface-300', value: 'hsl(215, 20%, 35%)' },
  { key: '--color-surface-400', value: 'hsl(217, 22%, 30%)' },
  { key: '--color-surface-500', value: 'hsl(219, 24%, 25%)' },
  { key: '--color-surface-600', value: 'hsl(221, 26%, 20%)' },
  { key: '--color-surface-700', value: 'hsl(223, 28%, 15%)' },
  { key: '--color-surface-800', value: 'hsl(225, 30%, 12%)' },
  { key: '--color-surface-900', value: 'hsl(230, 35%, 10%)' },

  { key: '--color-texture-050', value: '#ffffff' },
  { key: '--color-texture-100', value: '#ffffff' },
  { key: '--color-texture-200', value: '#FAF8F5' },
  { key: '--color-texture-300', value: '#F3F0ED' },
  { key: '--color-texture-400', value: '#E5E7EB' },
  { key: '--color-texture-500', value: '#a9adbb' },
  { key: '--color-texture-600', value: '#9597a1' },
  { key: '--color-texture-700', value: '#5B534A' },
  { key: '--color-texture-800', value: '#5B534A' },
  { key: '--color-texture-900', value: '#5B534A' },

  { key: '--color-success-050', value: 'hsl(106, 50%, 99%)' },
  { key: '--color-success-100', value: 'hsl(106, 50%, 90%)' },
  { key: '--color-success-200', value: 'hsl(106, 50%, 80%)' },
  { key: '--color-success-300', value: 'hsl(106, 50%, 70%)' },
  { key: '--color-success-400', value: 'hsl(106, 50%, 65%)' },
  { key: '--color-success-500', value: 'hsl(106, 50%, 60%)' },
  { key: '--color-success-600', value: 'hsl(106, 50%, 50%)' },
  { key: '--color-success-700', value: 'hsl(106, 50%, 40%)' },
  { key: '--color-success-800', value: 'hsl(106, 50%, 30%)' },
  { key: '--color-success-900', value: 'hsl(106, 50%, 20%)' },

  { key: '--color-info-050', value: 'hsl(203, 50%, 99%)' },
  { key: '--color-info-100', value: 'hsl(203, 50%, 90%)' },
  { key: '--color-info-200', value: 'hsl(203, 50%, 80%)' },
  { key: '--color-info-300', value: 'hsl(203, 50%, 70%)' },
  { key: '--color-info-400', value: 'hsl(203, 50%, 65%)' },
  { key: '--color-info-500', value: 'hsl(203, 50%, 60%)' },
  { key: '--color-info-600', value: 'hsl(203, 50%, 50%)' },
  { key: '--color-info-700', value: 'hsl(203, 50%, 40%)' },
  { key: '--color-info-800', value: 'hsl(203, 50%, 30%)' },
  { key: '--color-info-900', value: 'hsl(203, 50%, 20%)' },

  { key: '--color-warning-050', value: 'hsl(30, 90%, 99%)' },
  { key: '--color-warning-100', value: 'hsl(30, 90%, 90%)' },
  { key: '--color-warning-200', value: 'hsl(30, 90%, 80%)' },
  { key: '--color-warning-300', value: 'hsl(30, 90%, 70%)' },
  { key: '--color-warning-400', value: 'hsl(30, 90%, 65%)' },
  { key: '--color-warning-500', value: 'hsl(30, 90%, 60%)' },
  { key: '--color-warning-600', value: 'hsl(30, 90%, 50%)' },
  { key: '--color-warning-700', value: 'hsl(30, 90%, 40%)' },
  { key: '--color-warning-800', value: 'hsl(30, 90%, 30%)' },
  { key: '--color-warning-900', value: 'hsl(30, 90%, 20%)' },

  { key: '--color-danger-050', value: 'hsl(7, 63%, 99%)' },
  { key: '--color-danger-100', value: 'hsl(7, 63%, 90%)' },
  { key: '--color-danger-200', value: 'hsl(7, 63%, 80%)' },
  { key: '--color-danger-300', value: 'hsl(7, 63%, 70%)' },
  { key: '--color-danger-400', value: 'hsl(7, 63%, 60%)' },
  { key: '--color-danger-500', value: 'hsl(7, 63%, 50%)' },
  { key: '--color-danger-600', value: 'hsl(7, 63%, 40%)' },
  { key: '--color-danger-700', value: 'hsl(7, 63%, 30%)' },
  { key: '--color-danger-800', value: 'hsl(7, 63%, 20%)' },
  { key: '--color-danger-900', value: 'hsl(7, 63%, 10%)' },

  { key: '--color-growth-050', value: 'hsl(106, 50%, 99%)' },
  { key: '--color-growth-100', value: 'hsl(106, 50%, 90%)' },
  { key: '--color-growth-200', value: 'hsl(106, 50%, 80%)' },
  { key: '--color-growth-300', value: 'hsl(106, 50%, 70%)' },
  { key: '--color-growth-400', value: 'hsl(106, 50%, 65%)' },
  { key: '--color-growth-500', value: 'hsl(106, 50%, 60%)' },
  { key: '--color-growth-600', value: 'hsl(106, 50%, 50%)' },
  { key: '--color-growth-700', value: 'hsl(106, 50%, 40%)' },
  { key: '--color-growth-800', value: 'hsl(106, 50%, 30%)' },
  { key: '--color-growth-900', value: 'hsl(106, 50%, 20%)' },

  { key: '--color-decline-050', value: 'hsl(7, 63%, 99%)' },
  { key: '--color-decline-100', value: 'hsl(7, 63%, 90%)' },
  { key: '--color-decline-200', value: 'hsl(7, 63%, 80%)' },
  { key: '--color-decline-300', value: 'hsl(7, 63%, 70%)' },
  { key: '--color-decline-400', value: 'hsl(7, 63%, 60%)' },
  { key: '--color-decline-500', value: 'hsl(7, 63%, 50%)' },
  { key: '--color-decline-600', value: 'hsl(7, 63%, 40%)' },
  { key: '--color-decline-700', value: 'hsl(7, 63%, 30%)' },
  { key: '--color-decline-800', value: 'hsl(7, 63%, 20%)' },
  { key: '--color-decline-900', value: 'hsl(7, 63%, 10%)' },

  { key: '--color-contrast-primary-050', value: 'var(--root-color)' },
  { key: '--color-contrast-primary-100', value: 'var(--root-color)' },
  { key: '--color-contrast-primary-200', value: 'var(--root-color)' },
  { key: '--color-contrast-primary-300', value: 'var(--root-color)' },
  { key: '--color-contrast-primary-400', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-primary-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-primary-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-primary-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-primary-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-primary-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-secondary-050', value: 'var(--root-color)' },
  { key: '--color-contrast-secondary-100', value: 'var(--root-color)' },
  { key: '--color-contrast-secondary-200', value: 'var(--root-color)' },
  { key: '--color-contrast-secondary-300', value: 'var(--root-color)' },
  { key: '--color-contrast-secondary-400', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-secondary-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-secondary-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-secondary-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-secondary-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-secondary-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-accent-050', value: 'var(--root-color)' },
  { key: '--color-contrast-accent-100', value: 'var(--root-color)' },
  { key: '--color-contrast-accent-200', value: 'var(--root-color)' },
  { key: '--color-contrast-accent-300', value: 'var(--root-color)' },
  { key: '--color-contrast-accent-400', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-accent-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-accent-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-accent-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-accent-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-accent-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-neutral-050', value: 'var(--root-color)' },
  { key: '--color-contrast-neutral-100', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-neutral-200', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-neutral-300', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-neutral-400', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-neutral-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-neutral-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-neutral-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-neutral-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-neutral-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-surface-050', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-surface-100', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-surface-200', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-surface-300', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-surface-400', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-surface-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-surface-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-surface-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-surface-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-surface-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-texture-050', value: 'var(--root-color)' },
  { key: '--color-contrast-texture-100', value: 'var(--root-color)' },
  { key: '--color-contrast-texture-200', value: 'var(--root-color)' },
  { key: '--color-contrast-texture-300', value: 'var(--root-color)' },
  { key: '--color-contrast-texture-400', value: 'var(--root-color)' },
  { key: '--color-contrast-texture-500', value: 'var(--root-color)' },
  { key: '--color-contrast-texture-600', value: 'var(--root-color)' },
  { key: '--color-contrast-texture-700', value: 'var(--root-color)' },
  { key: '--color-contrast-texture-800', value: 'var(--root-color)' },
  { key: '--color-contrast-texture-900', value: 'var(--root-color)' },

  { key: '--color-contrast-success-050', value: 'var(--root-color)' },
  { key: '--color-contrast-success-100', value: 'var(--root-color)' },
  { key: '--color-contrast-success-200', value: 'var(--root-color)' },
  { key: '--color-contrast-success-300', value: 'var(--root-color)' },
  { key: '--color-contrast-success-400', value: 'var(--root-color)' },
  { key: '--color-contrast-success-500', value: 'var(--root-color)' },
  { key: '--color-contrast-success-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-success-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-success-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-success-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-info-050', value: 'var(--root-color)' },
  { key: '--color-contrast-info-100', value: 'var(--root-color)' },
  { key: '--color-contrast-info-200', value: 'var(--root-color)' },
  { key: '--color-contrast-info-300', value: 'var(--root-color)' },
  { key: '--color-contrast-info-400', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-info-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-info-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-info-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-info-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-info-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-warning-050', value: 'var(--root-color)' },
  { key: '--color-contrast-warning-100', value: 'var(--root-color)' },
  { key: '--color-contrast-warning-200', value: 'var(--root-color)' },
  { key: '--color-contrast-warning-300', value: 'var(--root-color)' },
  { key: '--color-contrast-warning-400', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-warning-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-warning-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-warning-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-warning-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-warning-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-danger-050', value: 'var(--root-color)' },
  { key: '--color-contrast-danger-100', value: 'var(--root-color)' },
  { key: '--color-contrast-danger-200', value: 'var(--root-color)' },
  { key: '--color-contrast-danger-300', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-danger-400', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-danger-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-danger-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-danger-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-danger-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-danger-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-growth-050', value: 'var(--root-color)' },
  { key: '--color-contrast-growth-100', value: 'var(--root-color)' },
  { key: '--color-contrast-growth-200', value: 'var(--root-color)' },
  { key: '--color-contrast-growth-300', value: 'var(--root-color)' },
  { key: '--color-contrast-growth-400', value: 'var(--root-color)' },
  { key: '--color-contrast-growth-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-growth-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-growth-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-growth-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-growth-900', value: 'var(--root-color-contrast)' },

  { key: '--color-contrast-decline-050', value: 'var(--root-color)' },
  { key: '--color-contrast-decline-100', value: 'var(--root-color)' },
  { key: '--color-contrast-decline-200', value: 'var(--root-color)' },
  { key: '--color-contrast-decline-300', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-decline-400', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-decline-500', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-decline-600', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-decline-700', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-decline-800', value: 'var(--root-color-contrast)' },
  { key: '--color-contrast-decline-900', value: 'var(--root-color-contrast)' },

  { key: '--theme-color-surface-d0', value: 'var(--color-surface-900)' },
  { key: '--theme-color-surface-d1', value: 'var(--color-surface-700)' },
  { key: '--theme-color-surface-d2', value: 'var(--color-surface-500)' },
  { key: '--theme-color-surface-d3', value: 'var(--color-surface-400)' },
  { key: '--theme-color-surface-d4', value: 'var(--color-surface-300)' },

  { key: '--root-bg-color', value: 'var(--color-surface-900)' },
  { key: '--text-color-main', value: 'hsl(210,50%,90%)' },
  { key: '--text-color-disabled', value: 'var(--color-neutral-700)' },
  { key: '--root-color', value: 'hsl(210,50%,90%)' },
  { key: '--theme-color-text-primary', value: 'var(--color-primary-200)' },
  { key: '--theme-color-link-hover', value: 'var(--color-primary-050)' },
  { key: '--surface-default-default-bg', value: 'var(--color-surface-900)' },
  { key: '--surface-default-disabled-bg', value: 'var(--color-surface-600)' },
  { key: '--theme-color-divider', value: 'var(--color-neutral-200)' },
  { key: '--theme-color-border-normal', value: 'var(--color-neutral-200)' },
  { key: '--theme-color-border-selected', value: 'var(--color-primary-100)' },
  { key: '--card-bg-color', value: 'var(--color-texture-500)' },

  // input
  { key: '--tc-input-base', value: 'var(--color-surface-300)' },
  { key: '--tc-input-focus', value: 'var(--color-surface-300)' },
  { key: '--tc-input-disabled', value: 'var(--color-surface-700)' },
  { key: '--tc-input-border', value: 'var(--color-primary-500)' },
  { key: '--tc-input-border-focus', value: 'var(--color-border-200)' },

  // cards
  { key: '--tc-frame-bg-normal', value: 'var(--color-surface-200)' },
  { key: '--background-default-color-1', value: '#18172b' },
  { key: '--background-default-color-2', value: '#514e91' },

  // Fonts
  { key: '--font-serif', value: '"Gelasio", serif' },
  { key: '--root-font', value: 'GothamPro,Gotham-Book,"Open Sans",Tahoma,"Segoe UI",sans-serif' },
  { key: '--font-sans', value: 'GothamPro,Gotham-Book,"Open Sans",Tahoma,"Segoe UI",sans-serif' },

  { key: '--tc-layout-text-color', value: 'var(--text-color-main)' },
  { key: '--tc-layout-accent-color', value: 'var(--color-primary-500)' },
  { key: '--tc-layout-app-bar-bg', value: 'var(--color-surface-900)' },

  // Denali AI
  { key: '--dai-color-bg', value: 'color-mix(in srgb, var(--color-ai-900) 30%, black)' },
  { key: '--dai-color-negative', value: 'var(--color-ai-700)' },
  { key: '--dai-color-surface1', value: 'var(--palette-purple-800)' },
  { key: '--dai-color-surface2', value: 'var(--palette-purple-800)' },
  { key: '--dai-color-surface3', value: 'var(--palette-purple-900)' },
  { key: '--dai-color-surface4', value: 'var(--color-neutral-700)' },
  { key: '--dai-color-surface-highlight', value: 'color-mix(in srgb, var(--color-texture-100) 50%, var(--color-ai-100))' },
  { key: '--dai-color-bg-inline', value: 'var(--color-neutral-050)' },
  { key: '--dai-color-active', value: 'var(--color-ai-400)' },
  { key: '--dai-contrast-active', value: 'var(--color-contrast-ai-400)' },
  { key: '--dai-color-highlight', value: 'var(--color-ai-400)' },
  { key: '--dai-contrast-highlight', value: 'var(--color-contrast-ai-400)' },
  { key: '--dai-color-hover', value: 'var(--color-ai-800)' },
  { key: '--dai-contrast-hover', value: 'var(--color-contrast-ai-800)' },
  { key: '--dai-color-text', value: 'var(--palette-blue-100)' },
  { key: '--dai-color-accent', value: 'var(--color-ai-300)' },
  { key: '--dai-contrast-accent', value: 'var(--color-contrast-ai-300)' },
  { key: '--dai-color-accent-low', value: 'var(--color-ai-500)' },
  { key: '--dai-color-border1', value: 'var(--color-neutral-300)' },
  { key: '--dai-color-border-accent', value: 'var(--color-ai-600)' },
  { key: '--dai-color-border-accent-hl', value: 'var(--color-ai-300)' },
  { key: '--dai-color-input', value: 'black' },
  { key: '--dai-contrast-input', value: 'var(--dai-color-text)' },
  { key: '--dai-color-notify', value: 'var(--color-ai-500)' },
  { key: '--dai-color-notify-border', value: 'var(--color-ai-600)' },
  { key: '--dai-contrast-notify', value: 'var(--color-contrast-ai-500)' },
  { key: '--dai-bg-nav', value: 'linear-gradient(var(--dai-color-bg), color-mix(in srgb, var(--dai-color-bg) 50%, black))' },
  { key: '--dai-color-icon-button', value: 'var(--color-neutral-400)' },
  { key: '--dai-color-icon-button-hover', value: 'var(--color-neutral-600)' },

  { key: '--dai-border1', value: '1px solid var(--dai-color-border1)' },
  { key: '--dai-border-2', value: '2.5px solid var(--dai-color-text)' },
  { key: '--dai-border-accent', value: '2.5px solid var(--dai-color-border-accent)' },
  { key: '--dai-bg', value: 'radial-gradient(circle, var(--dai-color-bg), black)' },
  { key: '--dai-color-text-low', value: 'color-mix(in srgb, var(--dai-color-text) 50%, transparent)' },
  { key: '--dai-color-text-dim', value: 'color-mix(in srgb, var(--dai-color-text) 25%, transparent)' }
]

darkTheme.$type = 'dark'
